"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanValidator = void 0;
const validator_1 = require("./validator");
class BooleanValidator extends validator_1.CommonValidator {
    merge(props) {
        return new BooleanValidator({ ...this.props, ...props });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        await (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateType]
        });
    };
    validateType = async ({ ctx, next }) => {
        if (typeof ctx.value === "boolean") {
            return next();
        }
        ctx.addError({ type: "boolean" });
    };
}
exports.BooleanValidator = BooleanValidator;
